module.exports = __webpack_public_path__ + "assets/ea3083c9b6066fdcb329466c5cf069bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artwork-3.png
// module id = 388
// module chunks = 1